module.exports = __webpack_public_path__ + "img/car.b42a1cb3.png";